import { AbstractBaseInputView } from './AbstractBaseInputView';
import { BaseInputAttribute, BaseInputProps } from '../types';

/**
 * @see {BaseInputFactory}
 * @example
 * ```ts
 * BaseInputFactory.create('text');
 * BaseInputFactory.create('text', 'MCO');
 * ```
 */
export class TextInputView extends AbstractBaseInputView<string> {
  constructor(value?: string, attribute?: BaseInputAttribute, props?: BaseInputProps) {
    super('text', value, attribute, props);
  }

  protected parseValue(value: string | undefined): string | undefined {
    return value;
  }
}
